import { EventedObject } from "../base/evented-object";
import { Text } from "../text/text";
export class Feature extends EventedObject {
    /**
     * 空间图形
     */
    get geometry() {
        return this._geometry;
    }
    /**
     * 属性信息
     */
    get properties() {
        return this._properties;
    }
    /**
    * 是否显示
    */
    get visible() {
        return this._visible;
    }
    /**
     * 是否显示
     */
    set visible(value) {
        this._visible = value;
    }
    /**
      * 构造函数
      * @param {Geometry} geometry - 空间图形
      * @param {Object} properties - 属性信息
      */
    constructor(geometry, properties) {
        super();
        /**
         * 属性信息
         */
        this._properties = {};
        /**
         * 是否显示
         */
        this._visible = true;
        /**
         * 前一要素
         * @remarks
         * 用于FeatureClass要素链表
         */
        this.prev = null;
        /**
         * 后一要素
         * @remarks
         * 用于FeatureClass要素链表
         */
        this.next = null;
        this._geometry = geometry;
        this._properties = properties;
    }
    /**
      * 绘制点
      * @param {CanvasRenderingContext2D} ctx - 绘图上下文
      * @param {Symbol} symbol - 渲染符号
      */
    draw(ctx, symbol) {
        this._geometry.draw(ctx, symbol);
    }
    /**
      * 标注要素
      * @remarks 调用空间坐标信息进行标注绘制
      * @param {CanvasRenderingContext2D} ctx - 绘图上下文
      * @param {Field} field - 标注字段
      * @param {Text} text - 标注符号
      */
    label(ctx, field, text = new Text()) {
        if (this.visible)
            this._geometry.label(ctx, this._properties[field.name], this.text || text);
    }
}
